module.exports = __webpack_public_path__ + "tea_bag_mockup_design_josif_pancic_cajevi_sipak_red_hibisci_flos.jpg?da4652f7cf4943a31768816e52e47d90";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/tea_bag_mockup_design_josif_pancic_cajevi_sipak_red_hibisci_flos.jpg
// module id = 81
// module chunks = 0